import { render, staticRenderFns } from "./TagsColumn.vue?vue&type=template&id=3f8b0f08&scoped=true"
import script from "./TagsColumn.vue?vue&type=script&lang=js"
export * from "./TagsColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../frontend-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8b0f08",
  null
  
)

export default component.exports